/**
 * Date line for workspace grid cards: "Apr 6 · 2026" (matches product mock).
 *
 * @param {string | null | undefined} dateString
 * @param {string} [localeTag='en-US'] — BCP 47, e.g. from i18n.language
 */
export const formatListCardDotDate = (dateString, localeTag = 'en-US') => {
  if (!dateString) return '—';
  try {
    const d = new Date(dateString);
    const locale = localeTag?.startsWith('es') ? 'es-ES' : 'en-US';
    const month = d.toLocaleDateString(locale, { month: 'short' });
    return `${month} ${d.getDate()} · ${d.getFullYear()}`;
  } catch {
    return '—';
  }
};
